module.exports = __webpack_public_path__ + "img/60.285ca6db.jpg";